import LegacyGift from "./LegacyGift";

export default LegacyGift;
